import React, { Component } from 'react';
import { ASSETS_FOLDER } from '../../../../../../../constants';
import { SMOKE_DAY } from '../../../../../../../content';
import * as Features from '../../../../../../../utils/Features';
import './TopSmokeParticle.css';

class TopSmokeParticle extends Component {
  constructor(props) {
    super(props);

    // ref
    this.partRef = React.createRef();

    // bind
    this.loop = this.loop.bind(this);
  }

  // -------------------------------------------------------
  // Lifecycle
  // -------------------------------------------------------

  componentDidMount() {
    this.resetPt();
    this.setRandomY();
    if (!Features.features.mobile) {
      // animation on desktop
      this.startLoop();
    } else {
      // just one update on mobile - to set opacity
      this.loopUpdate();
    }
  }

  componentWillUnmount() {
    this.stopLoop();
  }

  // -------------------------------------------------------
  // Reset
  // -------------------------------------------------------

  setRandomY() {
    const posY = Math.random() * SMOKE_DAY.MAX_Y;
    const posValue = -posY / this.vY;

    this.pt.x = -this.vX * posValue;
    this.pt.y = posY;
    this.pt.s = this.vS * posValue;

    this.updatePt();
  }

  resetPt() {
    // reset speeds
    this.vX = (-0.15 + Math.random() * 0.1) * 0.5;
    this.vY = 0.09 + Math.random() * 0.12;
    this.vS = (0.0007 + Math.random() * 0.0003) * 1.3;

    this.pt = {
      a: SMOKE_DAY.BASE_ALPHA,
      x: 0,
      y: 0,
      s: 0.2,
    };

    // reset state
    this.updatePt();
  }

  updatePt() {
    this.partRef.current.style.opacity = this.pt.a;
    this.partRef.current.style.transform = `scale(${this.pt.s}) translate(${
      this.pt.x
    }px, ${this.pt.y}px)`;
  }

  // -------------------------------------------------------
  // Loop
  // -------------------------------------------------------

  loopUpdate() {
    this.pt.x -= this.vX;
    this.pt.y -= this.vY;
    this.pt.s += this.vS;
    this.pt.a = SMOKE_DAY.BASE_ALPHA * (1 - this.pt.y / SMOKE_DAY.MAX_Y);

    this.updatePt();

    if (this.pt.y < SMOKE_DAY.MAX_Y) {
      this.resetPt();
    }
  }

  loop() {
    if (this.props.active) {
      this.loopUpdate();
    }
    this.loopRef = window.requestAnimationFrame(this.loop);
  }

  startLoop() {
    if (!this.loopRef) {
      this.loopRef = window.requestAnimationFrame(this.loop);
    }
  }

  stopLoop() {
    window.cancelAnimationFrame(this.loopRef);
  }

  render() {
    return (
      <img
        ref={this.partRef}
        className="smoke-particle"
        src={`${ASSETS_FOLDER}img/scene/smoke/p-smoke-${this.props.id % 3}.png`}
        alt=""
      />
    );
  }
}

export default TopSmokeParticle;



// WEBPACK FOOTER //
// ./src/components/App/Dukla/Scene/SceneTop/TopSmoke/TopSmokeParticle/TopSmokeParticle.js